
import Vue from 'vue'
import { VTooltip } from 'v-tooltip'
Vue.directive('tooltip', VTooltip)
export default {
  props: {
    diagram: {
      type: Object,
      default: () => ({})
    },
    isSlide: {
      type: Boolean,
      default: false
    }
  }
}
